import React, { useState } from 'react';

function ContactFormSection({
  title,
  description,
  subjectPrefix,
  enquiryOptions,
  imageSrc,
  imageAlt,
}) {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    enquiryType: enquiryOptions[0],
    message: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setContactForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const subject = encodeURIComponent(`${subjectPrefix}: ${contactForm.enquiryType}`);

    const body = encodeURIComponent(
      [
        `Name: ${contactForm.name}`,
        `Email: ${contactForm.email}`,
        `Enquiry type: ${contactForm.enquiryType}`,
        '',
        'Message:',
        contactForm.message,
      ].join('\n'),
    );

    window.location.href = `mailto:bahamaschessinstitute@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <section className="content-section">
      <div className="surface-card contact-card contact-card-refined contact-form-card">
        <div className="contact-column">
          <div className="contact-panel contact-form-intro">
            <div className="eyebrow">Contact</div>
            <h3>{title}</h3>
            <p>{description}</p>
            <p className="contact-email-inline">
              Email: <a href="mailto:bahamaschessinstitute@gmail.com">bahamaschessinstitute@gmail.com</a>
            </p>
            <div className="contact-visual">
              <img src={imageSrc} alt={imageAlt} />
            </div>
          </div>
        </div>

        <div className="contact-column">
          <form className="contact-panel contact-form" onSubmit={handleSubmit}>
            <div className="contact-form-grid">
              <label>
                Full name
                <input type="text" name="name" value={contactForm.name} onChange={handleChange} required />
              </label>

              <label>
                Email
                <input type="email" name="email" value={contactForm.email} onChange={handleChange} required />
              </label>

              <label className="form-span-full">
                Enquiry type
                <select name="enquiryType" value={contactForm.enquiryType} onChange={handleChange}>
                  {enquiryOptions.map((option) => (
                    <option key={option}>{option}</option>
                  ))}
                </select>
              </label>

              <label className="form-span-full contact-message-field">
                Message
                <textarea name="message" rows="5" value={contactForm.message} onChange={handleChange} required />
              </label>
            </div>

            <div className="button-row contact-actions">
              <button className="primary-btn" type="submit">
                Open Email Draft
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactFormSection;
